module.exports = __webpack_public_path__ + "assets/img/a3.67349367.jpg";